import { StandardButton } from '@components/buttons';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const BackToConcurButton = () => {
  const { t } = useTranslation('integrations');
  const onBackToConcur = useCallback(() => {
    window.close();
  }, []);

  return (
    <StandardButton
      color="inherit"
      sx={{ alignSelf: 'center', textTransform: 'none' }}
      variant="contained"
      onClick={onBackToConcur}
    >
      {t('integration/sapConcur.serverError.button')}
    </StandardButton>
  );
};
